import React from 'react';
import { createRoot } from "react-dom/client";
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import rootReducer from './rootReducer';
import { signalRMiddleware } from './middleware/signalRMiddleware';
import { history } from './App/history';
import { routerMiddleware } from "connected-react-router";
import MuiThemeProvider from './wrappers/MuiThemeProvider';
import ErrorBoundary from './wrappers/ErrorBoundary';

const middleWare = applyMiddleware(thunk, signalRMiddleware, routerMiddleware(history));
const store = createStore(rootReducer, middleWare);
// Dev-only handle used by the on-demand UI checks in SpecterrUiTests to read and drive the
// live editor state. Never exposed in a production build.
if (process.env.NODE_ENV !== 'production')
    window.__previewStore = store;

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

document.querySelector('.lds-ellipsis').remove();

root.render(
  <Provider store={store}>
    <Router>
      <MuiThemeProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </MuiThemeProvider>
    </Router>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();